/* RESPONSIBLE TEAM: team-standalone */

import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';
import { StandalonePlatform } from 'embercom/objects/standalone/constants';
import { ReactRoute } from 'embercom/lib/react-route';

class ZendeskFinTriggersRoute extends Route {
  @service declare appService: {
    app: {
      hasStandalonePlatform(platform: string): boolean;
    };
  };
  @service declare router: RouterService;

  async beforeModel() {
    if (!this.appService.app.hasStandalonePlatform(StandalonePlatform.Zendesk)) {
      this.router.transitionTo('apps.app.settings.standalone.integration');
      return;
    }
  }

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(ZendeskFinTriggersRoute);
